import { Inbox } from 'lucide-react';
import { C, FONTS } from '../../tokens/design';

export default function EmptyState({ title, sub }) {
  return (
    <div style={{ padding: '38px 24px', textAlign: 'center' }}>
      <div style={{
        width: 54, height: 54, borderRadius: 8,
        display: 'inline-flex', justifyContent: 'center', alignItems: 'center',
        color: C.t2, marginBottom: 12,
        background: `${C.s2}90`, border: `1px solid ${C.b1}`,
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.03)',
      }}>
        <Inbox size={28} strokeWidth={1.5} />
      </div>
      <div style={{ fontSize: 13, fontWeight: 700, color: C.t1, fontFamily: FONTS.sans }}>{title}</div>
      {sub && <div style={{ fontSize: 11, color: C.t2, marginTop: 5, lineHeight: 1.5, maxWidth: 460, marginLeft: 'auto', marginRight: 'auto' }}>{sub}</div>}
    </div>
  );
}
